/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */ // TODO: Remove this comment once the code is refactored
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import { renderToString } from 'react-dom/server';

import badges from 'assets/images/badges';

import BadgeDisplay from 'components/BadgeDisplay';
import ContentHeader from 'components/ContentHeader';
import Diploma from 'components/Diploma';
import Modal from 'components/Modal';
import RewardMenu from 'components/RewardMenu';
import ShareBox from 'components/ShareBox';
import SharingPopup from 'components/SharingPopup';

import { useChapters } from 'hooks/useChapters';
import { usePointsHandler } from 'hooks/usePointsHandler';
import { useSettings } from 'hooks/useSettings';
import { useUserInfo } from 'hooks/useUserInfo';

import Badge from 'views/BadgeView/Badge';
import BadgeContainer from 'views/BadgeView/BadgeContainer';

const params = new URLSearchParams(window.location.search);
let mobile = false;
if (params.get('mobile')) {
  mobile = true;
}

const INTRO_CHAPTER_PREFIX = 'intro-chapter-';
const SPECIALIZATION_PREFIX = 'specialization-';
const SUBAPP_PREFIX = 'subapp-';
const ITINERARY_BADGE_PREFIX = 'itinerary-badge-';
const TIER_I18N_KEYS = new Set(['bronze', 'silver', 'gold', 'platinum']);

const parseNumericSuffix = (actionValue, prefix) => {
  if (!actionValue || typeof actionValue !== 'string' || !actionValue.startsWith(prefix)) return null;
  const n = Number(actionValue.slice(prefix.length));
  return Number.isNaN(n) ? null : n;
};

const titleCaseWord = (s) => {
  if (!s || typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

const getBadgeShareTitle = (item, { chapterTitleById, categoryTitleById, moduleTitleBySessionAppId }) => {
  const apiTitle =
    item.badge_title ||
    item.badgeTitle ||
    item.badge_name ||
    item.badgeName ||
    item.name ||
    item.display_name ||
    item.displayName;
  if (apiTitle && String(apiTitle).trim()) return String(apiTitle).trim();

  const { action, action_value: actionValue, tier } = item;
  const act = (action && String(action).toLowerCase()) || '';

  if (act === 'intro-chapter') {
    const id = parseNumericSuffix(actionValue, INTRO_CHAPTER_PREFIX);
    if (id != null && chapterTitleById[id]) return chapterTitleById[id];
  }
  if (act === 'specialization') {
    const id = parseNumericSuffix(actionValue, SPECIALIZATION_PREFIX);
    if (id != null && categoryTitleById[id]) return categoryTitleById[id];
  }
  if (act === 'subapp') {
    const id = parseNumericSuffix(actionValue, SUBAPP_PREFIX);
    if (id != null && moduleTitleBySessionAppId[id]) return moduleTitleBySessionAppId[id];
  }
  if (act === 'itinerary-badge') {
    const id = parseNumericSuffix(actionValue, ITINERARY_BADGE_PREFIX);
    if (id != null && moduleTitleBySessionAppId[id]) return moduleTitleBySessionAppId[id];
  }

  if (tier && String(tier).trim()) {
    const tierKey = String(tier).toLowerCase();
    if (TIER_I18N_KEYS.has(tierKey)) return i18n.translate(`badgeView.${tierKey}`);
    return titleCaseWord(String(tier));
  }

  return 'badge';
};

/**
 * BadgeView
 *
 * A view component that displays each attained badge for the user. These badges being:
 *
 * - Bronze/Silver/Gold/Platinum badges: Based on the amount of completed trainings
 * - Specialization/Province badges: Based on completing specific specialization training chapters
 * - Specialization/Province completion: Obtained when completing both the main chapter and at least 1 city subchapter for
 *   that province.
 *
 * @returns {JSX.Element} A component that displays the user's badges and progress.
 */
const BadgeView = () => {
  const { tierBadges } = badges;

  const [showDiploma, setShowDiploma] = useState(false);
  const [showBadgePopout, setShowBadgePopout] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const loadingTimeoutRef = useRef(null);

  const [selectedBadge, setSelectedBadge] = useState({ url: '', title: '' });

  const {
    appId,
    lang: { langFile },
  } = useSettings();

  const { user } = useUserInfo();
  const { diplomaRate, itineraries = [], chapters = [], categories = [], subapps = [] } = useChapters();

  const { tiers, completedItems, totalPoints, getTieredValue, loaded: loadedPointsHandler } = usePointsHandler();

  const actions = useMemo(() => ['intro-chapter', 'specialization', 'itinerary-badge', 'subapp'], []);

  const tierIndex = tiers && Math.min(getTieredValue(), tiers.length - 1);
  const currentPath = window.location.pathname;

  const handleDiplomaOpen = () => setShowDiploma(true);
  const handleDiplomaClose = () => setShowDiploma(false);
  const diplomaImage = `https://cms.travpromobile.com/api/app/diploma?first_name=${user.first_name}&last_name=${user.last_name}&email=${user.email}&app_id=${appId}&lang=${langFile}_${langFile.toUpperCase().replace('PT', 'BR').replace('KO', 'KR')}`;

  const handleBadgeOpen = (badgeData) => {
    const { url, title } = badgeData;
    if (mobile) {
      window.ReactNativeWebView.postMessage(`image:${url}`);
    } else {
      setSelectedBadge({ url, title });
      setShowBadgePopout(true);
    }

  };
  const handleBadgeClose = () => setShowBadgePopout(false);

  const badgeTitleLookup = useMemo(() => {
    const chapterTitleById = {};
    chapters.forEach((ch) => {
      const id = Number(ch.id);
      if (!Number.isNaN(id) && ch.title) chapterTitleById[id] = ch.title;
    });
    const categoryTitleById = {};
    categories.forEach((cat) => {
      const id = Number(cat.id);
      if (!Number.isNaN(id) && cat.title) categoryTitleById[id] = cat.title;
    });
    const moduleTitleBySessionAppId = {};
    const indexModules = (list) => {
      list.forEach((category) => {
        (category.modules || []).forEach((mod) => {
          const sid = Number(mod.sessionAppId);
          if (!Number.isNaN(sid) && mod.title) moduleTitleBySessionAppId[sid] = mod.title;
        });
      });
    };
    indexModules(subapps);
    indexModules(itineraries);
    return { chapterTitleById, categoryTitleById, moduleTitleBySessionAppId };
  }, [chapters, categories, subapps, itineraries]);

  const getBadgeShareTitleForItem = useCallback(
    (item) => getBadgeShareTitle(item, badgeTitleLookup),
    [badgeTitleLookup],
  );

  // Add loading state management for iOS compatibility
  useEffect(() => {
    if (loadedPointsHandler && tiers) {
      const timer = setTimeout(() => {
        setIsLoading(false);

        // iOS rendering fix
        const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (iOS) {
          const el = document.createElement('div');
          el.style.display = 'none';
          document.body.appendChild(el);
          requestAnimationFrame(() => {
            document.body.removeChild(el);
          });
          window.scrollBy(0, 1);
          window.scrollBy(0, -1);
        }
      }, 100);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [loadedPointsHandler, tiers]);

  // Force loading to false if data is available but loading is still true
  useEffect(() => {
    if (loadedPointsHandler && tiers && isLoading) {
      console.log('Data loaded but still loading, forcing state update');
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 50);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [loadedPointsHandler, tiers, isLoading]);

  useLayoutEffect(() => {
    if (loadedPointsHandler && tiers) {
      setIsLoading(false);
    }
  }, [loadedPointsHandler, tiers]);

  const renderBadges = useCallback(
    (tierName) => {
      if (!loadedPointsHandler) return null;

      return completedItems
        .filter(({ tier, badge }) => (tier && tier.toLowerCase()) === tierName.toLowerCase() && !!badge)
        .map((item) => {
          const { id, badge, region } = item;
          const shareTitle = getBadgeShareTitleForItem(item);
          return (
            <Badge
              key={id}
              badgeImg={badge}
              title={shareTitle}
              active
              rounded={false}
              onClick={() => handleBadgeOpen({ url: badge, title: shareTitle })}
              region={region}
            />
          );
        });
    },
    [completedItems, getBadgeShareTitleForItem, loadedPointsHandler],
  );

  const renderLevels = useCallback(
    (tierName) => {
      if (!loadedPointsHandler) return null;

      const hideTitle = ['specialization', 'itinerary-badge', 'subapp'].includes(
        (tierName && tierName.toLowerCase()) || '',
      );

      return completedItems
        .filter(({ action, badge }) => (action && action.toLowerCase()) === tierName.toLowerCase() && !!badge)
        .map((item) => {
          const { id, badge, region } = item;
          const shareTitle = getBadgeShareTitleForItem(item);
          return (
            <Badge
              key={id}
              badgeImg={badge}
              title={shareTitle}
              hideTitle={hideTitle}
              active
              rounded={false}
              onClick={() => handleBadgeOpen({ url: badge, title: shareTitle })}
              region={region}
            />
          );
        });
    },
    [completedItems, getBadgeShareTitleForItem, loadedPointsHandler],
  );

  const itineraryMetaBySessionAppId = useMemo(
    () =>
      (itineraries || []).reduce((acc, category) => {
        const { openableSection = false, modules = [] } = category || {};
        modules.forEach((module) => {
          const { sessionAppId, region } = module || {};
          if (!Number.isNaN(Number(sessionAppId))) {
            acc[Number(sessionAppId)] = { openableSection, region };
          }
        });
        return acc;
      }, {}),
    [itineraries],
  );

  /**
   * The memoized rendered tiers, with all obtained badges grouped by tier. The first tier is always included and holds
   * the diploma badge. Curently excludes any other tiers that don't have any badges.
   */
  const renderedTiers = useMemo(() => {
    if (!loadedPointsHandler) return null;

    const badgeContainers = tiers.reduce((acc, tier, index) => {
      const { copy, title } = tier;
      const renderedBadges = renderBadges(title);

      // Only push last one
      if (renderedBadges.length > 0 && index === tierIndex && tier.completedItems === tier.count) {
        acc.push(
          <React.Fragment key={title}>
            <div key={title} className="badge-display__wrapper">
              <h1 className="badgeView__text">{copy}</h1>
            </div>
            <hr className="colored" />
          </React.Fragment>,
        );
      }
      return acc;
    }, []);

    // Certifications (action: intro-chapter), Experience badges (action: specialization), and Specialization badges (action: subapp)
    const badgeItems = actions.reduce((acc, action, index) => {
      const renderedBadges = renderLevels(action); // Assuming this returns an array of badge components with a region key

      const diplomaBadgeTier = index === 0;
      const diplomaCompleted = diplomaRate >= 100;

      const image = `https://cms.travpromobile.com/api/app/diploma?first_name=preview&last_name=account&app_id=1441&lang=${langFile}_${langFile.toUpperCase()
        .replace('PT', 'BR')
        .replace('KO', 'KR')}`;

      if (!diplomaCompleted) {
        acc.push(<div className="badge-display__wrapper" />);
        return acc;
      }

      if (action === 'itinerary-badge') {
        const itineraryItems = completedItems.filter(
          ({ action: completedAction, badge }) =>
            (completedAction && completedAction.toLowerCase()) === 'itinerary-badge' && !!badge,
        );

        if (itineraryItems.length === 0) return acc;

        const getSessionAppIdFromActionValue = (actionValue) => {
          if (!actionValue) return null;
          const parsed = Number(String(actionValue).replace('itinerary-badge-', ''));
          return Number.isNaN(parsed) ? null : parsed;
        };

        const itineraryBadges = itineraryItems.map((item) => {
          const { id, badge, region, action_value: actionValue } = item;
          const shareTitle = getBadgeShareTitleForItem(item);
          const sessionAppId = getSessionAppIdFromActionValue(actionValue);
          const meta = (sessionAppId && itineraryMetaBySessionAppId[sessionAppId]) || {};
          return {
            openableSection: !!meta.openableSection,
            region: meta.region || region,
            component: (
              <Badge
                key={id}
                badgeImg={badge}
                title={shareTitle}
                hideTitle
                active
                rounded={false}
                onClick={() => handleBadgeOpen({ url: badge, title: shareTitle })}
                region={region}
              />
            ),
          };
        });

        const nonOpenableBadges = itineraryBadges.filter(({ openableSection }) => !openableSection);
        const openableBadges = itineraryBadges.filter(({ openableSection }) => openableSection);

        const groupedOpenableBadges = openableBadges.reduce((group, itineraryBadge) => {
          const regionKey = itineraryBadge.region && itineraryBadge.region.toLowerCase();
          const regionLabel = (regionKey && i18n.translate(`missing.${regionKey}`)) || i18n.translate('badgeView.other');
          const nextGroup = { ...group };
          nextGroup[regionLabel] = nextGroup[regionLabel] || [];
          nextGroup[regionLabel].push(itineraryBadge.component);
          return nextGroup;
        }, {});

        acc.push(
          <React.Fragment key="itinerary-badges-title">
            <hr className="top-margin" />
            <h1 className="badgeView__title--badge-display secondary">
              {i18n.translate('badgeView.itinerariesBadgesSectionTitle')}
            </h1>
          </React.Fragment>,
        );

        if (nonOpenableBadges.length > 0) {
          acc.push(
            <BadgeContainer key="badge-container-itinerary-non-openable" showLine>
              <div className="container__badges">{nonOpenableBadges.map(({ component }) => component)}</div>
            </BadgeContainer>,
          );
        }

        Object.entries(groupedOpenableBadges).forEach(([regionLabel, regionBadges]) => {
          acc.push(
            <React.Fragment key={`itinerary-badge-${regionLabel}`}>
              <h3 className="badgeView__region__title">{regionLabel}</h3>
              <div className="container__badges">{regionBadges}</div>
            </React.Fragment>,
          );
        });
        return acc;
      }

      if (action === 'subapp') {
        // Group badges by region
        const groupedBadges = renderedBadges.reduce((group, badge) => {
          const regionKey = badge.props.region && badge.props.region.toLowerCase(); // Replace 'badge.props.region' with the actual way to access the region key in your badge component
          const region = (regionKey && i18n.translate(`missing.${regionKey}`)) || i18n.translate('badgeView.other');
          const newGroup = { ...group };
          newGroup[region] = newGroup[region] || [];
          newGroup[region].push(badge);
          return newGroup;
        }, {});

        if (renderedBadges.length > 0) {
          acc.push(
            <React.Fragment key="subapp-section-title">
              <hr className="top-margin" />
              <h1 className="badgeView__title--badge-display secondary">
                {i18n.translate('badgeView.partnerSpecializationBadgesSectionTitle')}
              </h1>
            </React.Fragment>,
          );
        }

        // Render badges grouped by region
        Object.entries(groupedBadges).forEach(([region, regionBadges]) => {
          acc.push(
            <React.Fragment key={`${action}-${region}`}>
              <h3 className="badgeView__region__title">{region}</h3>
              <div className="container__badges">{regionBadges}</div>
            </React.Fragment>,
          );
        });
        return acc;
      }

      if (action !== 'subapp' && (renderedBadges.length > 0 || diplomaBadgeTier) && !mobile) {
        acc.push(
          <React.Fragment key={action}>
            <hr className="top-margin" />
            {diplomaBadgeTier && (
              <h1 className="badgeView__title--badge-display secondary">
                {i18n.translate('badgeView.diploma')}
              </h1>
            )}
            {action === 'specialization' && renderedBadges.length > 0 && (
              <h1 className="badgeView__title--badge-display secondary">
                {i18n.translate('badgeView.experiencesBadgesSectionTitle')}
              </h1>
            )}
            <BadgeContainer key={`badge-container-${action}`} showLine>
              <div className="container__badges">
                {diplomaBadgeTier && (
                  <a
                    className={`container__progressDiploma ${diplomaCompleted ? 'completed' : ''}`}
                    onClick={handleDiplomaOpen}
                  >
                    <img
                      // eslint-disable-next-line max-len
                      src={image}
                      alt="diploma"
                    />
                  </a>
                )}
                {renderedBadges}
              </div>
            </BadgeContainer>
          </React.Fragment>,
        );
      }
      if (action !== 'subapp' && (renderedBadges.length > 0 || diplomaBadgeTier) && mobile) {
        acc.push(
          <React.Fragment key={action}>
            <hr className="top-margin" />
            {diplomaBadgeTier && (
              <h1 className="badgeView__title--badge-display secondary">
                {i18n.translate('badgeView.diploma')}
              </h1>
            )}
            {action === 'specialization' && renderedBadges.length > 0 && (
              <h1 className="badgeView__title--badge-display secondary">
                {i18n.translate('badgeView.experiencesBadgesSectionTitle')}
              </h1>
            )}
            <BadgeContainer key={`badge-container-${action}`} showLine>
              <div className="container__badges">
                {diplomaBadgeTier && (
                  <a
                    className={`container__progressDiploma ${diplomaCompleted ? 'completed' : ''}`}
                    onClick={() => window.ReactNativeWebView.postMessage(`image:${diplomaImage}`)}
                  >
                    <img
                      // eslint-disable-next-line max-len
                      src={image}
                      alt="diploma"
                    />
                  </a>
                )}
                {renderedBadges}
              </div>
            </BadgeContainer>
          </React.Fragment>,
        );
      }
      return acc;
    }, []);

    return (
      <div className="badgeContainer points__container">
        <div className="badgeView__badge-display">
          {badgeContainers}
          {badgeItems}
        </div>
      </div>
    );
  }, [
    loadedPointsHandler,
    tiers,
    actions,
    renderBadges,
    tierIndex,
    renderLevels,
    diplomaRate,
    langFile,
    diplomaImage,
    completedItems,
    itineraryMetaBySessionAppId,
    getBadgeShareTitleForItem,
  ]);

  // Loading fallback for iOS
  if (isLoading) {
    return (
      <div className="contentContainer badgeView">

        {mobile && (
          <style>
            {
              '\
      .buttons__diploma { display: none !important; } .sharebox__buttons { display: none !important; } .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }'
            }
          </style>
        )}
        {currentPath === '/main/rewards/achievements' && <RewardMenu />}
        <ContentHeader header={i18n.translate('badgeView.title')} subtitle={i18n.translate('badgeView.subtitle')} />
        <hr />
        <div className="content-box">
          <div className="badgeView__loading">
            <div className="loading-spinner">
              <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contentContainer badgeView">
      {currentPath === '/main/rewards/achievements' && <RewardMenu />}
      {mobile && (
        <style>
          {
            '\
      .buttons__diploma { display: none !important; } .sharebox__buttons { display: none !important; } .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }'
          }
        </style>
      )}
      <Modal show={showBadgePopout} onHide={handleBadgeClose} bgClose autosize>
        {/* FIXME: TEMP Props */}
        <ShareBox
          image={selectedBadge.url}
          url={selectedBadge.url}
          title={selectedBadge.title}
          subject={i18n.translate('sharing.shareSubjectBadge')}
          body={i18n.translate('sharing.shareBodyBadge', { chapterTitle: selectedBadge.title })}
          email
          download
          size="sm"
        />
      </Modal>

      <ContentHeader header={i18n.translate('badgeView.title')} subtitle={i18n.translate('badgeView.subtitle')} />
      <hr />

      <div className="content-box">
        {loadedPointsHandler && tiers ? ( // More explicit conditional rendering
          <div className="badgeContainer points__container">
            <h1 className="badgeView__title--badge-display secondary">
              {i18n.translate('badgeView.badgeDisplayTitle')}
            </h1>
            <BadgeDisplay
              tierBadges={tierBadges}
              tiers={tiers}
              tierIndex={tierIndex}
              totalPoints={totalPoints}
              layout="longBar"
              hideBadge
              completedItems={completedItems}
              hasPopout
            />
            <div className="badgeView__title--tiers">
              {tiers.map((tier, index) => (
                <div
                  key={tier.title}
                  className={`tier-title ${tierIndex === index ? 'active' : ''} ${tier.completedItems >= tier.count ? '' : 'disabled'
                    }`}
                >
                  {!mobile && (
                    <a
                      href={Object.values(tierBadges)[index]}
                      data-fancybox={tier.title}
                      data-options={JSON.stringify({
                        buttons: ['download', 'share', 'close'],
                        share: {
                          tpl: renderToString(<SharingPopup url={Object.values(tierBadges)[index]} downloadable={false} />),
                        },
                        btnTpl: {
                          download: renderToString(
                            <a
                              href={`https://stack.travpromobile.com/download.php?url=${Object.values(tierBadges)[index]}&name=${tier.title}`}
                            >
                              <button type='button' data-fancybox-download className='fancybox-button fancybox-button--download' title='Download'>
                                <FontAwesomeIcon icon={['fas', "download"]} />
                              </button>
                            </a>
                          )
                        },
                      })}
                    >
                      <img
                        className="badge"
                        src={Object.values(tierBadges)[index]}
                        alt="Logo"
                      />
                    </a>
                  )}
                  {mobile && (
                    <a onClick={() => window.ReactNativeWebView.postMessage(`image:${Object.values(tierBadges)[index]}`)}>
                      <img
                        className="badge"
                        src={Object.values(tierBadges)[index]}
                        alt="Logo"
                      />
                    </a>
                  )}
                  <span className="title">
                    {Math.min(tier.completedItems, tier.count)}
                    {' / '}
                    {tier.count} {i18n.translate('badgeView.complete')}
                  </span>
                </div>
              ))}
            </div>
            {!mobile && (
              <Modal show={showDiploma} onHide={handleDiplomaClose} bgClose autosize>
                <Diploma
                  appId={appId}
                  firstName={user.first_name}
                  lastName={user.last_name}
                  email={user.email}
                  key={user.firstName}
                />
              </Modal>
            )}

          </div>
        ) : (
          // Fallback content when data is not loaded
          <div className="badgeView__fallback">
            <div className="loading-spinner">
              <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
            </div>
          </div>
        )}

        {renderedTiers}
      </div>

    </div>
  );
};

export default BadgeView;
